import { encryptData, decryptData } from "@/utils/encryptStorage";

export interface User {
  userID: string;
  userMail: string;
  userName: string;
  adminType?: string;
  roleID?: string;
  isSuperAdmin?: boolean;
  kitchenIDs: any;
  status?: string;
  sessionValid?: boolean;
}

const USER_KEY = "octopusUser";

export const getUser = (): User | null => {
  const encrypted = (typeof window !== "undefined")
    ? localStorage.getItem(USER_KEY)
    : null;

  if (!encrypted) return null;

  const decrypted = decryptData(encrypted);
  if (decrypted) {
    return decrypted as User;
  }

  try {
    const oldUser = JSON.parse(encrypted);
    localStorage.setItem(USER_KEY, encryptData(oldUser));

    return oldUser as User;
  } catch (err) {
    console.error("User data is corrupted. Clearing storage.", err);
    localStorage.removeItem(USER_KEY);
    return null;
  }
};


export const saveUser = (user: User): void => {
  const encrypted = encryptData(user);
  localStorage.setItem(USER_KEY, encrypted);
};

export const editUser = (updatedFields: Partial<User>): void => {
  const existingUser = getUser();
  if (!existingUser) return;

  const updatedUser = { ...existingUser, ...updatedFields };
  const encrypted = encryptData(updatedUser);

  localStorage.setItem(USER_KEY, encrypted);
};

export const deleteUser = (): void => {
  localStorage.removeItem(USER_KEY);
};
